import * as React from 'react';
import {
  CardContainer,
  CardHeaderStyled,
  CardStyled,
  Description,
  DescriptionDiv,
  ImageDiv,
  TitleSpan,
} from './styles';
import { Widget } from '../../../pages/UserGroupsPage';
import { LinkStyled } from '../../../pages/InitialPage/styles';
import {
  isDownloadWidget,
  isSpinradWidget,
  isStoryWidget,
} from '../../../utils/fixedWidgets';

interface Props {
  widget: Widget;
  categoryColor?: string;
}

const HomePageCard: React.FC<Props> = ({ widget, categoryColor }) => {
  return (
    <>
      <CardContainer id="cardContainer">
        <LinkStyled
          to={
            isDownloadWidget(widget)
              ? `/downloads?id=${widget.widgetId}`
              : isStoryWidget(widget)
                ? `/story?id=${widget.widgetId}`
                : isSpinradWidget(widget)
                  ? `/spinrad?id=${widget.widgetId}`
                  : widget.url
          }
          target={widget.type === 'external' ? '_blank' : '_self'}
          rel={widget.type === 'external' ? 'noopener noreferrer' : ''}
        >
          <CardStyled id="cardStyled" $categoryColor={categoryColor}>
            <CardHeaderStyled id="headerTittle" $categoryColor={categoryColor}>
              <TitleSpan>{widget.name}</TitleSpan>
            </CardHeaderStyled>
            {widget.urlImage && (
              <ImageDiv>
                <img
                  src={widget.urlImage}
                  style={{ maxHeight: '90%', marginTop: '2%', maxWidth: '50%' }}
                  hidden={widget.urlImage === ''}
                />
              </ImageDiv>
            )}

            <DescriptionDiv>
              <Description>{widget.description}</Description>
            </DescriptionDiv>
          </CardStyled>
        </LinkStyled>
      </CardContainer>
    </>
  );
};

export default HomePageCard;
